











import Vue from "vue";

export default Vue.extend({
  name: "Loading",

  components: {},

  data: () => ({}),
  computed: {},
  methods: {},
  mounted() {
    //
  }
});
